import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    width?: number;
    height?: number;
};

export const InfoCircleIcon = ({ color = 'currentColor', width = 160, height = 160, ...props }: Props) => {
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 160 160"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M80 20C91.8672 20 103.467 23.519 113.334 30.1118C123.201 36.7047 130.891 46.0754 135.433 57.039C139.974 68.0026 141.162 80.0664 138.847 91.7056C136.532 103.344 130.818 114.035 122.426 122.426C114.035 130.818 103.344 136.532 91.7056 138.847C80.0664 141.162 68.0026 139.974 57.039 135.433C46.0754 130.891 36.7047 123.201 30.1118 113.334C23.519 103.467 20 91.8672 20 80C20 64.087 26.3214 48.8258 37.5736 37.5736C48.8258 26.3214 64.087 20 80 20Z"
                stroke={color}
                strokeWidth="6"
            />
            <path d="M80 48V88" stroke={color} strokeWidth="6" strokeLinecap="round" />
            <path
                d="M84 108C84 105.791 82.2091 104 80 104C77.7909 104 76 105.791 76 108C76 110.209 77.7909 112 80 112C82.2091 112 84 110.209 84 108Z"
                fill={color}
            />
        </svg>
    );
};
